import { useQuery } from '@tanstack/react-query';
import ms from 'ms';

import { toast } from '@hivebrite/design-system/Toast';

import type { RelatedNewsItem } from 'hb-react/shared/apps/News/types';

import { getRelatedNewsRequest } from '../requests/getRelatedNewsRequest';

interface UseQueryRelatedNewsProps {
  enabled: boolean;
  groupId?: string;
  newsId?: string;
}

export const useQueryRelatedNews = ({
  enabled,
  groupId,
  newsId,
}: UseQueryRelatedNewsProps): {
  data: Array<RelatedNewsItem>;
  isLoading: boolean;
  refetch: () => void;
} => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['relatedNews', newsId],
    enabled: enabled && !!newsId,
    queryFn: async ({ signal }) => {
      try {
        const {
          data: { data },
        } = await getRelatedNewsRequest({
          groupId,
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          newsId: newsId!,
          signal,
        });

        return data;
      } catch (error) {
        toast.error(__('Sorry, an error occurred'));
        throw error;
      }
    },
    staleTime: ms('5m'),
  });

  return {
    data: data || [],
    isLoading,
    refetch,
  };
};
